PJQ.views.budget.BulkEditLineItemsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-bulk-edit-line-items'),
        maxWidth: 400,
        onSave: null
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        if(_.size(this.options.lineItems) === 0){
            return;
        }

        this.model = new PJQ.models.BaseModel();
    },
    renderData: function () {
        return {
            lineItems: this.options.lineItems,
            model: this.model,
            enableStoredMaterials: this.options.enableStoredMaterials,
            enableRetainage: this.options.enableRetainage
        }
    },
    afterRender: function() {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            onChange: ($el, attribute, value) => {
                if(_.size($el.val()) > 0){
                    this.model.set(attribute, value);
                }
                else{
                    this.model.unset(attribute);
                }
            }
        });

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);
        PJQ.helpers.inputHelpers.inputMaskPercent(this.$('.input-percent'), 2, true);
    },
    save: function() {
        _.each(this.options.lineItems, (lineItem) => {
            _.each(this.model.attributes, (value, key) => {
                lineItem.set(key, value/100)
            });
        });

        if(typeof this.options.onSave === 'function'){
            this.options.onSave();
        }
        this.removeModal();
    }
});